import { Card, CardContent } from '@/components/Card'
import styles from './CommunicationView.module.css'
import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { byDesign } from '@/infra/design'
import imgChatDisabledUrl from '@/assets/misc/img_chat-disabled.svg'
import ChatDisabledIllustration from '@/components/SpotIllustration/ChatDisabledIllustration'
import { type ReactNode } from 'react'
import { IconButton } from '@/components/IconButton'
import { Tooltip } from '@/components/Tooltip'

export interface CommunicationViewProps {
  children: ReactNode
}

export function CommunicationView({ children }: CommunicationViewProps) {
  return (
    <div className={styles.root}>
      <Card unconstrained>
        <CardContent scroll compact>
          {children}
        </CardContent>
      </Card>
    </div>
  )
}

export interface ChatDisabledProps {
  corporateMode: boolean
}

export function ChatDisabled({ corporateMode }: ChatDisabledProps) {
  return (
    <EmptyState pad>
      {!corporateMode && (
        <EmptyStateIllustration
          src={imgChatDisabledUrl}
          illustration={byDesign(undefined, ChatDisabledIllustration)}
        />
      )}
      <EmptyStateTitle>Chat Disabled</EmptyStateTitle>
      <EmptyStateDescription>
        Please contact an administrator to allow chat permissions.
      </EmptyStateDescription>
    </EmptyState>
  )
}

export interface NoConversationProps {
  corporateMode: boolean
}

export function NoConversation({ corporateMode }: NoConversationProps) {
  return (
    <EmptyState pad>
      {!corporateMode && (
        <EmptyStateIllustration
          src={imgChatDisabledUrl}
          illustration={byDesign(undefined, ChatDisabledIllustration)}
        />
      )}
      <EmptyStateTitle>No Conversation Yet</EmptyStateTitle>
      <EmptyStateDescription>
        Once this job gets submitted, you will be able to chat.
      </EmptyStateDescription>
    </EmptyState>
  )
}

export interface RevealJobNotesButtonProps {
  onPress: () => unknown
}

/**
 * Takes the chat composer's note mode toggle's place when job notes are on.
 */
export function RevealJobNotesButton({ onPress }: RevealJobNotesButtonProps) {
  return (
    <Tooltip placement="top" content="Job notes moved here">
      <IconButton
        name="chat-note"
        label="Job notes"
        variant="ghost"
        onPress={onPress}
        size={45}
      />
    </Tooltip>
  )
}
